"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTerms = exports.StyledSubHeading = exports.StyledImageWrapper = exports.StyledImageHeroWrapper = exports.StyledImageHero = exports.StyledHeading = exports.StyledDescription = exports.StyledCopyWrapper = exports.ImageHeroSpanButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var ratio1by1 = 'calc(550 / 1280 * 100%)';
var ratio4by3 = 'calc(740 / 1280 * 100%)';
var spanButtonHoverCss = "\n\tspan {\n\t\tbox-shadow: var(--elevation-shadow-xxs);\n\t\tbackground-color: var(--color-brand-mid);\n\n\t\t@media screen and (min-width: ".concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\tbox-shadow: var(--elevation-shadow-xs);\n\t\t}\n\n\t\t@media screen and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\tbox-shadow: var(--elevation-shadow-s);\n\t\t}\n\t}\n");
var StyledImageHeroWrapper = exports.StyledImageHeroWrapper = _styledComponents["default"].a.attrs({
  className: 'fuse-image-hero'
}).withConfig({
  displayName: "styled-image-hero__StyledImageHeroWrapper",
  componentId: "sc-w0hteb-0"
})(["position:relative;text-decoration:none;@media screen and (min-width:", "){padding-bottom:", ";}&:hover{", "}&:focus-visible{outline:2px solid var(--color-functional-focus);", "}&:active{span{box-shadow:inset 0 0 0 2px var(--color-global-white);color:var(--color-global-white);background-color:var(--color-brand-dark);}}"], _grid.gridConfig.m.minWidth, ratio1by1, spanButtonHoverCss, spanButtonHoverCss);
var StyledImageHero = exports.StyledImageHero = _styledComponents["default"].div.attrs({
  className: 'fuse-image-hero__container',
  'data-testid': 'fuse-image-hero__container'
}).withConfig({
  displayName: "styled-image-hero__StyledImageHero",
  componentId: "sc-w0hteb-1"
})(["display:flex;flex-direction:column;@media screen and (min-width:", "){flex-direction:", ";position:absolute;top:0;left:0;width:100%;height:100%;padding:2px;}"], _grid.gridConfig.m.minWidth, function (props) {
  return props.position === 'Left' ? 'row' : 'row-reverse';
});
var StyledImageWrapper = exports.StyledImageWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-image-hero__image-wrapper',
  'data-testid': 'fuse-image-hero__image-wrapper'
}).withConfig({
  displayName: "styled-image-hero__StyledImageWrapper",
  componentId: "sc-w0hteb-2"
})(["position:relative;padding-bottom:75%;@media screen and (min-width:", "){width:", ";padding-bottom:inherit;}img{position:absolute;top:0;left:0;height:100%;width:100%;object-fit:cover;}"], _grid.gridConfig.m.minWidth, function (image) {
  return image.ratio === '1:1' ? ratio1by1 : ratio4by3;
});
var StyledCopyWrapper = exports.StyledCopyWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-image-hero__text-content',
  'data-testid': 'fuse-image-hero__text-content'
}).withConfig({
  displayName: "styled-image-hero__StyledCopyWrapper",
  componentId: "sc-w0hteb-3"
})(["display:flex;flex-direction:column;box-sizing:border-box;justify-content:center;padding:var(--spacing-global-space5);z-index:1;@media screen and (min-width:", "){justify-content:center;width:", ";padding:", ";}@media screen and (min-width:", "){padding:0 var(--spacing-global-space10);}h3,p{margin-top:var(--spacing-global-space3);}p{margin-bottom:0;}"], _grid.gridConfig.m.minWidth, function (image) {
  return image.ratio === '1:1' ? "calc(100% - ".concat(ratio1by1, ")") : "calc(100% - ".concat(ratio4by3, ")");
}, function (_ref) {
  var ratio = _ref.ratio,
    position = _ref.position;
  if (ratio === '1:1') return '0 var(--spacing-global-space9)';
  return position === 'Left' ? '0 var(--spacing-global-space9) 0 var(--spacing-global-space7)' : '0 var(--spacing-global-space7) 0 var(--spacing-global-space9)';
}, _grid.gridConfig.l.minWidth);
var StyledHeading = exports.StyledHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-image-hero__heading',
  'data-testid': 'fuse-image-hero__heading'
}).withConfig({
  displayName: "styled-image-hero__StyledHeading",
  componentId: "sc-w0hteb-4"
})(["background:var(--color-global-white);width:fit-content;"]);
var StyledSubHeading = exports.StyledSubHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-image-hero__sub-heading',
  'data-testid': 'fuse-image-hero__sub-heading'
}).withConfig({
  displayName: "styled-image-hero__StyledSubHeading",
  componentId: "sc-w0hteb-5"
})([""]);
var StyledDescription = exports.StyledDescription = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-image-hero__description',
  'data-testid': 'fuse-image-hero__description'
}).withConfig({
  displayName: "styled-image-hero__StyledDescription",
  componentId: "sc-w0hteb-6"
})([""]);
var StyledTerms = exports.StyledTerms = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-image-hero__terms',
  'data-testid': 'fuse-image-hero__terms'
}).withConfig({
  displayName: "styled-image-hero__StyledTerms",
  componentId: "sc-w0hteb-7"
})([""]);
var ImageHeroSpanButton = exports.ImageHeroSpanButton = (0, _styledComponents["default"])(_buttons.SpanButton).attrs({
  className: 'fuse-image-hero__span-button',
  'data-testid': 'fuse-image-hero__span-button'
}).withConfig({
  displayName: "styled-image-hero__ImageHeroSpanButton",
  componentId: "sc-w0hteb-8"
})(["margin-top:var(--spacing-global-space5);width:fit-content;@media screen and (min-width:", "){margin-top:var(--spacing-global-space6);}@media screen and (min-width:", "){margin-top:var(--spacing-global-space7);}"], _grid.gridConfig.m.minWidth, _grid.gridConfig.l.minWidth);